import { render, staticRenderFns } from "./list-favourites.vue?vue&type=template&id=6c114482&"
import script from "./list-favourites.vue?vue&type=script&lang=ts&"
export * from "./list-favourites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports